import { isLive } from '@utils/env';

import i18n from '@plugins/i18n';

import authGuard from './middleware/authGuard';
import investorOnboarding from './routes/investor-onboarding';
import library from './routes/library';
import offers from './routes/offers';
import portfolio from './routes/portfolio';
import proposals from './routes/proposals';
import reports from './routes/reports';
import settings from './routes/settings';
import shortlists from './routes/shortlists';
import system from './routes/system';

const routes = [
    {
        path: '/',
        component: () => import('@/views/Index.vue'),
        beforeEnter: authGuard,
        children: [
            {
                path: '/',
                name: 'Dashboard',
                component: () => import('@/views/Dashboard.vue'),
                meta: {
                    title: i18n.t('dashboard'),
                    organisations: ['ADVISER', 'INVESTOR']
                }
            },
            ...library,
            ...offers,
            ...shortlists,
            ...proposals,
            ...portfolio,
            ...reports,
            ...system,
            ...settings,
            ...investorOnboarding
        ]
    },
    {
        path: '/risk-summary',
        name: 'RiskSummary',
        component: () => import('@/views/RiskSummary.vue'),
        meta: {
            title: i18n.t('risk_summary')
        }
    },
    {
        path: '/investor-portfolio-restricted-notice',
        name: 'InvestorPortfolioRestrictedNotice',
        component: () => import('@/views/InvestorPortfolioRestrictedNotice.vue')
    },
    {
        path: '/adviser-investor-portfolio-restricted-notice',
        name: 'AdviserInvestorPortfolioRestrictedNotice',
        component: () => import('@/views/AdviserInvestorPortfolioRestrictedNotice.vue'),
        meta: {
            retainQuerySelectors: ['investor_id', 'organisation_id']
        }
    },
    {
        path: '/debug/:param1?',
        name: 'Debug',
        component: () => import('@/views/Debug.vue'),
        beforeEnter: (to, from, next) => {
            if (isLive()) {
                next({ name: 'PageError' });
            }

            next();
        }
    },
    {
        path: '/problem',
        name: 'FatalError',
        component: () => import('@/views/error/FatalError.vue'),
        meta: {
            title: i18n.t('weve_encountered_a_problem')
        }
    },
    {
        path: '*',
        name: 'PageError',
        props: true,
        component: () => import('@/views/error/PageError.vue'),
        meta: {
            title: i18n.t('weve_encountered_a_problem'),
            public: true
        }
    }
];

export default routes;
